export default __webpack_public_path__ + "static/phoneMobile2-1d7c03435d5e9219e1dc627412eb918d.png";